import { render, staticRenderFns } from "./PrintPatient.vue?vue&type=template&id=4ae5d0aa&"
import script from "./PrintPatient.vue?vue&type=script&lang=js&"
export * from "./PrintPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports